import { useEffect, useState } from 'react'

import useL1NS from './useL1NS'

const useProfilePath = (address: `0x${string}` | string | undefined) => {
  const { getL1nsName } = useL1NS()

  const [profilePath, setProfilePath] = useState<string>(`/profile/${address}`)

  // Get L1NS name when address changes
  useEffect(() => {
    const fetchName = async (addr: `0x${string}` | string) => {
      const name = await getL1nsName(addr)
      if (name) {
        setProfilePath(`/profile/${name}`)
      } else {
        setProfilePath(`/profile/${addr}`)
      }
    }
    if (address) {
      fetchName(address)
    }
  }, [address, getL1nsName])

  return profilePath
}

export default useProfilePath
